var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
var defaultSortParam = 'expedient';
var defaultSortDirection = 'asc';
var AcusosFilterService = /** @class */ (function (_super) {
    __extends(AcusosFilterService, _super);
    function AcusosFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AcusosFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('expedient', filter.expedient ? filter.expedient.toString() : '')
            .append('tipus', filter.tipus)
            .append('resultat', filter.resultat ? filter.resultat.toString() : '')
            .append('dataInici', filter.dataInici ? filter.dataInici.toLocaleString('dd/MM/yyyy') : '')
            .append('dataFinal', filter.dataFinal ? filter.dataFinal.toLocaleString('dd/MM/yyyy') : '')
            .append('nomComplet', filter.nomComplet)
            .append('numDenuncia', filter.numDenuncia ? filter.numDenuncia.toString() : '')
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return AcusosFilterService;
}(CustomFilterService));
export { AcusosFilterService };
